import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'

import { getOrganization } from '../../api/organizations'
import { currentUserSelector } from '../../redux/selectors/users'

export function useOrganization() {
  const user = useSelector(currentUserSelector)
  return useQuery(
    ['organization', user.organization, user.id, Boolean(user.is_org_admin)],
    () => getOrganization(user.organization!),
    { enabled: Boolean(user.id && user.organization && !user.vendor_membership), retry: false }
  )
}
